export default __webpack_public_path__ + "static/media/hero.081c37ae.svg";